import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyPublicationEditContainerProps } from "../../../../interfaces/containers";
import EntryPoint from "../../../../pages/Profile/MyPublications/Edit";
import {
    getPublication, 
    getArticlesFromPublication, 
    setUploadImages,
    updatePublication, 
    cleanUpdate, 
    cleanAll, 
    deletePublicationImage,
    cleanImagesSaved,

} from "../../../../actions/publication";
import { getYears, setIsNegotiate, getAdditionalCharacters, setAdditionalCharacters, postPublicationsImagesForEdit } from "../../../../actions/salePost";
import { getModels, getVersions, getBrands } from "../../../../actions/publications";
import { getMyPublicationsRequest } from "../../../../actions/profile";
import { getAdminBrand } from "../../../../actions/auth";

function mapStateToProps(state: MyPublicationEditContainerProps) {
    return{
        publication: state.publication,
        models: state.publications.models,
        versions: state.publications.versions,
        updateReducer: state.publication.update,
        brands: state.publications.brands,
        additionalCharacters: state.salePost.additional_characters,
        years: state.salePost.years,
        user: state.auth.user,
        adminBrand: state.auth.adminBrand,
        opportunity: state.publication.opportunity
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getModels,
        getVersions,
        getPublication,
        getArticlesFromPublication,
        setUploadImages,
        updatePublication,
        cleanAll,
        cleanUpdate,
        postPublicationsImages: postPublicationsImagesForEdit,
        deletePublicationImage,
        cleanImagesSaved,
        getMyPublicationsRequest,
        getYears,
        getBrands,
        setIsNegotiate,
        getAdditionalCharacters,
        setAdditionalCharacters,
        getAdminBrand,
        cleanGetYears: () => {},
        cleanGetModels: () => {},
        cleanGetBrands: () => {},
        cleanGetVersions: () => {}
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);